import { render, staticRenderFns } from "./CaipanPicker.vue?vue&type=template&id=beb1bafa&"
import script from "./CaipanPicker.vue?vue&type=script&lang=js&"
export * from "./CaipanPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports